<template>
  <nav :class="$style.nav">
    <div :class="$style.card">
      <h4>Add user attributes and assign resources</h4>
      <p>Add user attributes, assign a device or directory, or add to a user group</p>
      <a
        :href="userRoute"
        @click="closeModal"
      >Go to Users</a>
    </div>
    <div :class="$style.card">
      <h4>Add users to user groups</h4>
      <p>Assign user groups to give users the correct access to the resources they need</p>
      <a
        :href="userGroupRoute"
        @click="closeModal"
      >Go to User Groups</a>
    </div>
    <div :class="$style.card">
      <h4>Add users to device groups</h4>
      <p>Assign device groups to give users the right level of access to multiple devices</p>
      <a
        :href="deviceGroupRoute"
        @click="closeModal"
      >Go to Device Groups</a>
    </div>
  </nav>
</template>

<script>
import {
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import ModalEventBus from 'client/components/Modal/ModalEventBus';

export default {
  name: 'ImportUsersResultsNav',

  data() {
    return {
      deviceGroupRoute: ItemTypeRoutes[ItemTypeConsts.deviceGroup],
      userGroupRoute: ItemTypeRoutes[ItemTypeConsts.userGroup],
      userRoute: ItemTypeRoutes[ItemTypeConsts.systemUser],
    };
  },

  methods: {
    closeModal() {
      ModalEventBus.close();
    },
  },
};
</script>

<style module>
@value (jcInformational100) from '~css/brand-colors.css';

.nav {
  align-content: center;
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
  width: 100%;
}

.card {
  background-color: jcInformational100;
  font-size: 1rem;
  line-height: 1.26rem;
  padding: 16px;
  padding-bottom: 21px;
  width: 31.8%;
}

.card h4 {
  font-size: 1.23rem;
  line-height: 1.46rem;
  margin-bottom: 0.61rem;
}

.card p {
  margin-bottom: 1.23rem;
}
</style>
